import permissions from './permissions';

function checkMethod(method, permission) {
  return permission.httpMethod === method;
}

// TODO: Support `:type` as a url part
function checkUrl(url, permission) {
  return permission.urlPattern.test(url);
}

export default function isPermitted({ method, url }) {
  return permissions
    .get()
    .some(
      permission =>
        checkMethod(method, permission) && checkUrl(url, permission),
    );
}
